import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { postCustomerApi, customerrealestateList,customerpaymentList,postaddcustomercommentApi,getpaymentstatusApi, Postcustomerpayment, getcustunitMapById, getCustomerListapi, Postcustomerrealestate, postaddAddressApi, getAllnationsListApi, getCustomerByIdApi, getCartListapi, updateCustomerApi, getaddressListApi, } from '../services/Apis';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
export default function useCustomer() {
    const auth_status = useSelector(state => state.globalslice.auth_status);
    const initial_page = useSelector(state => state.globalslice.initial_page);
    const sorting_data = useSelector(state => state.globalslice.sorting_data);

    const queryClient = useQueryClient();
    const navigate = useNavigate()
    const postCustomer = useMutation({
        mutationFn: (formData) => {
            if (formData.id) {
                return updateCustomerApi(formData) // if id exists — update
            } else {
                return postCustomerApi(formData);    // else — create
            }
        },
        onSuccess: (data) => {
            // toast.success('Customer Updated Successfully', 200)
            queryClient.getQueryCache().findAll().forEach((query) => {
                if (query.queryKey[0] === 'customer') {
                    queryClient.removeQueries({ queryKey: query.queryKey });
                }
            });
            queryClient.invalidateQueries({ queryKey: ['customerbyid', { id: data.data }] });

            if (data.success == true) {
                toast.success(" Customer  Updated Successfully", { duration: 2000 });
                navigate('/admin/customer')
            } else if (data.success == false) {
                toast.error(data.message)
            }

        },
        onError: (error) => {
            console.error('customer failed', error);
        },
    });

    const postCustomeraddress = useMutation({
        mutationFn: (formData) => {
            postaddAddressApi(formData)
        },
        onSuccess: (data) => {
            toast.success('Customer Address Updated Successfully', 200)

            queryClient.getQueryCache().findAll().forEach((query) => {
                if (query.queryKey[0] === 'customeraddress') {

                    queryClient.removeQueries({ queryKey: query.queryKey });
                }
            });
            // queryClient.invalidateQueries({ queryKey: ['customeraddress'], exact: false });
        },
        onError: (error) => {
            console.error('customeraddress failed', error);
        },
    });

      const postCustomercomment = useMutation({
        mutationFn: (formData) => {
            postaddcustomercommentApi(formData)
        },
        onSuccess: (data) => {
            toast.success('Customer Comment Successfully', 200)

            queryClient.getQueryCache().findAll().forEach((query) => {
                if (query.queryKey[0] === 'customercomment') {

                    queryClient.removeQueries({ queryKey: query.queryKey });
                }
            });
            // queryClient.invalidateQueries({ queryKey: ['customeraddress'], exact: false });
        },
        onError: (error) => {
            console.error('customercomment failed', error);
        },
    });
    const PostcustomerrealestateApi = useMutation({
        mutationFn: (formData) => {
            if (formData.id) {
                return Postcustomerrealestate(formData);
            } else {
                return Postcustomerrealestate(formData);
            }
        },
        onSuccess: (data) => {
            toast.success('Updated Successfully', 200)

            queryClient.getQueryCache().findAll().forEach((query) => {
                if (query.queryKey[0] === 'customerrealestateList') {
                    queryClient.removeQueries({ queryKey: query.queryKey });
                }
            });
            queryClient.invalidateQueries({ queryKey: ['custunitMapById', { id: data.data }] });
            // navigate('/projects/ProjectsList');
        },
        onError: (error) => {
            console.error(' operation failed', error);
        },
    });

    const postCustomerpayment = useMutation({
        mutationFn: (formData) => {
            return Postcustomerpayment(formData)
        },
        onSuccess: (response) => {

            const data = response.data;

            if (data) {
                window.location.href = data.payment_url; // ✅ redirect
            } else {
                toast.error(data.message);
            }
        },
        onError: (error) => {
            console.error('postCustomerpayment failed', error);
        },
    });

    const getCustomerlist = (project_id, perPage) => {
        return useQuery({
            queryKey: ['customer', {project_id :project_id, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'created_date', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }],
            queryFn: () => getCustomerListapi({ project_id:project_id, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'created_date', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
    const getaddressList = (id) => {
        return useQuery({
            queryKey: ['customeraddress', { 'page': initial_page, limit: process.env.REACT_APP_PER_PAGE, 'customer_id': id, sort: sorting_data.sortBy, order: sorting_data.sortOrder, search: sorting_data.search }],
            queryFn: () => getaddressListApi({ 'page': initial_page, limit: process.env.REACT_APP_PER_PAGE, 'customer_id': id, sort: sorting_data.sortBy, order: sorting_data.sortOrder, search: sorting_data.search }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
    const customerrealestateListApi = (perPage, id) => {
        return useQuery({
            queryKey: ['customerrealestateList', { page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : '', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', "customer_id": id, search: sorting_data.search }],
            queryFn: () => customerrealestateList({ page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : '', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', "customer_id": id, search: sorting_data.search }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
      const customerpaymentListApi = (perPage, id,unit_id) => {
        return useQuery({
            queryKey: ['customerpaymentList', { page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : '', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', "customer_id": id, search: sorting_data.search ,"unit_id":unit_id}],
            queryFn: () => customerpaymentList({ page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : '', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', "customer_id": id, search: sorting_data.search,"unit_id":unit_id }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getCartListApi = (id,unit_id) => {
        return useQuery({
            queryKey: ['cartlist', { 'customer_id': id,'unit_id': id,'page': initial_page, limit: process.env.REACT_APP_PER_PAGE, sort: sorting_data.sortBy, order: sorting_data.sortOrder, search: sorting_data.search }],
            queryFn: () => getCartListapi({ 'customer_id': id,'unit_id': id, 'page': initial_page, limit: process.env.REACT_APP_PER_PAGE, sort: sorting_data.sortBy, order: sorting_data.sortOrder, search: sorting_data.search }),
            enabled: !!id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getcustunitMapByIdApi = (id) => {
        return useQuery({
            queryKey: ['custunitMapById', { 'id': id }],
            queryFn: () => getcustunitMapById(id),
            enabled: !!id,   // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
    const getCustomerById = (id) => {
        return useQuery({
            queryKey: ['customerbyid', { 'id': id }],
            queryFn: () => getCustomerByIdApi(id),
            enabled: !!id,   // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getAllnationsList = () => {
        return useQuery({
            queryKey: ['AllnationsListApi'],
            queryFn: () => getAllnationsListApi(),
            // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

      const getPaymentstatus = (id) => {
        return useQuery({
            queryKey: ['getpaymentstatus', { 'id': id }],
            queryFn: () => getpaymentstatusApi(id),
            enabled: !!id,   // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    return {
        postCustomer: postCustomer,
        postCustomercomment: postCustomercomment,
        PostcustomerrealestateApi,
        getCustomerlist: getCustomerlist,
        getCustomerById: getCustomerById,
        getCartListApi: getCartListApi,
        getaddressList: getaddressList,
        getcustunitMapByIdApi: getcustunitMapByIdApi,
        customerrealestateListApi: customerrealestateListApi,
        customerpaymentListApi: customerpaymentListApi,
        postCustomeraddress: postCustomeraddress,
        getAllnationsList: getAllnationsList,
        postCustomerpayment: postCustomerpayment,
        getPaymentstatus:getPaymentstatus
    };
}